<template>
  <iframe ref="printFrame" style="display:none;" class="print-area"></iframe>
</template>

<script>
export default {
  name: 'PrintSalonContract',
  props: { htmlContent: String },
  mounted() {
    this.writeContent()
  },
  watch: {
    htmlContent() {
      this.writeContent()
    },
  },
  methods: {
    writeContent() {
      const doc = this.$refs.printFrame.contentDocument
      doc.open()
      doc.write(`
        <html>
          <head>
<style>
@page { size: A4; margin: 20mm; }
body {
  margin: 0;
  font-family: 'Microsoft JhengHei', sans-serif;
  color: #000;
  font-size: 14px;
  line-height: 1.6;
}

/* 抬頭 */
.header { display:flex; justify-content:space-between; margin-bottom:20px; }
.header .left { font-size:24px; font-weight:bold; }
.header .right { font-size:16px; }

/* 區塊標題 */
h3.section-title { font-size:18px; margin:8px 0; font-weight:bold; }
.signatures h3 { font-size:20px; font-weight:bold; margin:12px 0; }

/* 資料表格 (甲方/寵物/乙方/付款) */
.info-table {
  width:100%;
  border-collapse:collapse;
  margin-bottom:20px;
}
.info-table td {
  border:1px solid #999;
  padding:6px;
  font-size:13px;
  font-weight:normal;
}
.checkbox { margin:0 10px; }

/* 服務內容 */
.service-meta {
  display:flex;
  justify-content:space-between;
  margin-bottom:10px;
  font-size:14px;
}
.service-table {
  width:100%;
  border-collapse:collapse;
  margin-bottom:20px;
}
.service-table th, .service-table td {
  border:1px solid #999;
  padding:6px;
}
.service-table th { text-align:center; }
.service-table th.item { text-align:left; }   /* 項目置左 */
.service-table th.subtotal { text-align:right; } /* 小計置右 */
.service-table td.item { text-align:left; }
.service-table td.price { text-align:right; }   /* 售價置右 */
.service-table td.qty { text-align:center; }     /* 數量置中 */
.service-table td.subtotal, .service-table td.paytotal { text-align:right; } /* 小計置右 */
.service-table td.paytotal strong { font-weight:bold; }

/* 契約條款 */
.terms-text p {
  margin:6px 0;
  line-height:1.8;
  text-align:left;
}

/* 簽名區塊 */
.signatures {
  margin-top:40px;
  line-height:2.2;
  page-break-inside: avoid;
  page-break-before: auto;
  page-break-after: auto;
}

.date-footer {
  text-align:center;
  font-size:20px; 
  margin-top:50px;
  padding-top:20px;
  page-break-inside: avoid; /* 與簽名區塊同頁 */
}

</style>

          </head>
          <body>${this.htmlContent}</body>
        </html>
      `)
      doc.close()
    },
    print() {
      this.$refs.printFrame.contentWindow.print()
    },
  },
}
</script>
